import type { FaireProductEntity } from "../../entity_types/product";

export const p_d3membekvh: FaireProductEntity = {
  token: "p_d3membekvh",
  type: "product",
  name: "There's No Taste Like Bad Taste Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/7e746c59be33ffebba1eca57cd0af3ff8d1509b715ff0ba09bae12c92880a828.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a92a72dd66a4ae6e486cb4a12ed357a265804edbf9371a95e2f398cb212c8830.jpeg",
    "https://cdn.faire.com/fastly/59ddcf475b9e5c6efd2439ea010bd0edb46ed413f809a9a61e8f7eb013d0f642.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/959f58b05f4f7fe7728b91d6e1fa407814396ab8b1b02d176b8b063cf471a501.jpeg",
    "https://cdn.faire.com/fastly/4c4e3486ffd4f1c09f50caed47133e4262df9d4cc6fd52d98e727e9443af4d3d.jpeg",
    "https://cdn.faire.com/fastly/192f982c85086f49110145cc5a9c1c9435e7ea6ae258e928081f1b927d1fc5ee.jpeg",
    "https://cdn.faire.com/fastly/d0dbacff1a78ae86d9eb577aa9177b89886deb55b5bf4a99116d07a1ad4311ab.jpeg"
  ],
  priceDollars: 3.38,
  description: "Limited Availability - Will Not Restock\n\nBad taste, good socks. These socks are a tribute to your questionable excellence.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:26.325Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
